var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButIllusionsAr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-3f5c670b-b6bf-4b4e-a6c8-ccdece1f4d08",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 190.6,
    height: 32.9,
    viewBox: "0 0 190.6 32.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "uuid-e82569e5-d2a8-47ba-8bed-1024a0a62704",
    "data-name": "a0018366-fa39-418a-bf72-ca34e470021e"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m24.8.5c-6.6,0-12,5.3-12,11.9,0,2.5.8,4.9,2.2,6.9l4.4,6.4c-.4-.8-.7-1.8-.7-2.7,0-3.2,2.6-5.9,5.8-6-2.5-.1-4.4-2.3-4.3-4.7.1-2.5,2.3-4.4,4.7-4.3,2.5.1,4.4,2.3,4.3,4.7-.1,2.3-2,4.1-4.3,4.3,3.2.1,5.8,2.8,5.8,6,0,.9-.2,1.9-.7,2.7l4.4-6.4c3.8-5.4,2.6-12.8-2.8-16.7-1.9-1.4-4.3-2.2-6.8-2.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.8,17.7c-2.9,0-5.3,2.4-5.2,5.3h0c0,1.1.3,2.2,1,3.1l4.3,6.3,4.3-6.3c.6-.9,1-2,1-3.1-.1-2.9-2.4-5.3-5.4-5.3Zm0,7.4c-1.1,0-2-.9-2-2s.9-2,2-2,2,.9,2,2h0c0,1.1-.9,1.9-2,2h0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m55.7,25.9V8.9h3.4v17h-3.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.3,25.9V8.9h3.3v17h-3.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.9,25.9V8.9h3.3v17h-3.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.6,25.9v-1.8c-.4.7-1.1,1.2-1.8,1.6-.7.4-1.5.6-2.3.6s-1.5-.2-2.2-.5c-.6-.3-1.1-.9-1.4-1.5-.3-.9-.5-1.8-.4-2.7v-7.8h3.3v5.7c0,1.1,0,2.1.2,3.2.1.4.3.7.7.9.4.2.8.4,1.2.3.5,0,1.1-.2,1.5-.5s.7-.7.9-1.1c.2-1.1.3-2.2.3-3.3v-5.2h3.3v12.3l-3.3-.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.9,22.4l3.3-.5c.1.6.4,1.1.8,1.4.5.4,1.2.5,1.8.5.7,0,1.3-.1,1.9-.5.3-.2.4-.5.4-.9,0-.2-.1-.4-.2-.6-.3-.2-.7-.4-1.1-.4-1.7-.3-3.4-.8-5-1.6-.9-.6-1.5-1.7-1.5-2.8,0-1,.5-2,1.3-2.7,1.1-.8,2.5-1.2,3.9-1.1,1.3-.1,2.6.2,3.8.8.8.6,1.4,1.4,1.7,2.4l-3.1.6c-.1-.4-.4-.8-.7-1.1-.5-.3-1-.4-1.6-.4s-1.3.1-1.8.4c-.2.1-.4.4-.4.7,0,.2.1.5.3.6,1,.4,2,.7,3,.9,1.3.2,2.5.7,3.6,1.4.7.6,1.1,1.5,1,2.4,0,1.1-.5,2.2-1.4,2.9-1.2.9-2.7,1.3-4.2,1.2-1.4.1-2.8-.3-4-1-.9-.5-1.5-1.5-1.8-2.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.2,11.9v-3h3.3v3h-3.3Zm0,14v-12.3h3.3v12.3s-3.3,0-3.3,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.1,19.6c0-1.1.3-2.2.8-3.1.5-1,1.3-1.8,2.3-2.3s2.1-.8,3.3-.8c1.7-.1,3.4.6,4.6,1.8s1.8,2.9,1.8,4.6c.1,1.7-.6,3.4-1.8,4.6-1.2,1.2-2.8,1.9-4.5,1.8-1.1,0-2.2-.3-3.2-.8s-1.8-1.3-2.3-2.2c-.8-1.1-1.1-2.4-1-3.6Zm3.3.2c-.1,1,.2,2,.9,2.8,1,1.2,2.8,1.3,4,.3.1-.1.2-.2.3-.3.6-.8.9-1.8.9-2.8.1-1-.2-2-.9-2.8-1-1.2-2.8-1.3-4-.3-.1.1-.2.2-.3.3-.7.8-1,1.8-.9,2.8h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.5,25.9h-3.3v-6.3c0-.9,0-1.7-.2-2.6-.1-.4-.4-.7-.7-.9-.3-.2-.7-.3-1.1-.3-.5,0-1.1.2-1.5.5-.4.3-.8.7-.9,1.2-.2.9-.3,1.9-.2,2.8v5.6h-3.3v-12.3h3v1.8c.9-1.3,2.4-2.1,4.1-2.1.7,0,1.3.1,2,.4.5.2,1,.6,1.4,1,.3.4.5.9.6,1.4.1.7.2,1.5.2,2.2v7.6h-.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.7,22.4l3.3-.5c.1.6.4,1.1.8,1.4.5.4,1.2.5,1.8.5.7,0,1.3-.1,1.9-.5.3-.2.4-.5.4-.9,0-.2-.1-.4-.2-.6-.3-.2-.7-.4-1.1-.4-1.7-.3-3.4-.8-5-1.6-.9-.6-1.5-1.7-1.5-2.8,0-1,.5-2,1.3-2.7,1.1-.8,2.5-1.2,3.9-1.1,1.3-.1,2.6.2,3.8.8.8.6,1.4,1.4,1.7,2.4l-3.1.6c-.1-.4-.4-.8-.7-1.1-.5-.3-1-.4-1.6-.4s-1.3.1-1.8.4c-.2.1-.4.4-.4.7,0,.2.1.5.3.6,1,.4,2,.7,3,.9,1.3.2,2.5.7,3.6,1.4.7.6,1.1,1.5,1,2.4,0,1.1-.5,2.2-1.4,2.9-1.2.9-2.7,1.3-4.2,1.2-1.4.1-2.8-.3-4-1-.9-.5-1.6-1.5-1.8-2.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173,25.9h-3.7l-1.5-3.9h-6.8l-1.4,3.9h-3.6l6.6-17h3.6l6.8,17Zm-6.3-6.7l-2.3-6.3-2.3,6.3h4.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.9,25.9V8.9h7.2c1.3-.1,2.7.1,4,.5.8.3,1.5.9,2,1.6.5.8.8,1.7.7,2.7,0,1.2-.4,2.3-1.1,3.2-.9.9-2.1,1.5-3.4,1.6.7.4,1.3.9,1.8,1.4.7.9,1.4,1.8,2,2.8l2.1,3.3h-4.1l-2.5-3.7c-.5-.9-1.2-1.7-1.8-2.5-.3-.3-.6-.6-1-.7-.6-.2-1.1-.2-1.7-.2h-.7v7.1h-3.5v-.1Zm3.4-9.8h2.5c1,.1,2.1,0,3.1-.2.4-.1.7-.4,1-.7.2-.4.4-.8.3-1.3,0-.5-.1-1-.5-1.4-.3-.4-.8-.6-1.3-.7-.3,0-1.1-.1-2.5-.1h-2.7l.1,4.4Z",
    style: {
      fill: "#fff"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButIllusionsAr);
export default __webpack_public_path__ + "static/media/butIllusionsAR.ee7c1169c34d591bc6d53e193b8d789b.svg";
export { ForwardRef as ReactComponent };